import React from 'react';
import CartButton from './CartButton';
import CartWidget from './CartWidget';
import clickOutside from 'modules/click-outside';
import { Actions } from '../reducer';

const Container = (props) => {
  return (
    <div>
      <CartButton {...props} />
      <div className="cart-widget-container">
        <CartWidget {...props} />
      </div>
    </div>
  );
};


export default clickOutside(
  (e, { dispatch }) => dispatch(Actions.close())
)(Container);



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/components/Container.js
 **/